module.exports = __webpack_public_path__ + "img/paper.e3b88304.png";